import { memo, useContext, useEffect } from 'react';
import { CallTopicContext } from '../../../contexts/CallTopicContext';
import { findCurrentCallTopicUtterance } from '../../../utils/callTopicUtils';
import { MediaPlaybackTimeContext } from '../../context/MediaPlaybackTimeContext';
const CurrentCallTopicUpdater = () => {
  const currentTime = useContext(MediaPlaybackTimeContext);
  const {
    selectedTopicUtterances,
    currentTopicUtterance,
    setCurrentTopicUtterance
  } = useContext(CallTopicContext);
  useEffect(() => {
    // check if we have any selected call topic utterances
    if (selectedTopicUtterances.length === 0) {
      return;
    }

    // Check if the previously calculated currentTopicUtterance is still valid
    if (currentTopicUtterance && currentTopicUtterance.startTimeSeconds <= Math.ceil(currentTime) && currentTopicUtterance.endTimeSeconds > Math.ceil(currentTime)) {
      return;
    }

    // Compute the new currentTopicUtterance using the utility function
    const foundTopicExcerpt = findCurrentCallTopicUtterance(selectedTopicUtterances, currentTime);

    // If foundTopicExcerpt has changed from the current value, update the context
    if (foundTopicExcerpt !== currentTopicUtterance) {
      setCurrentTopicUtterance(foundTopicExcerpt);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTime, selectedTopicUtterances]);
  return null;
};
export default /*#__PURE__*/memo(CurrentCallTopicUpdater);